// @flow
import * as React from 'react';
import styled, { css } from 'styled-components';
import theme from 'styled-theming';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { FontAwesomeSize } from '../../types';
import { Button } from './Button';
import Themes from '../../styling/themes';
import { useDelay } from '../../hooks';

const backgroundColor = theme('mode', {
  light: Themes.light.backgroundColor,
  dark: Themes.dark.backgroundColor,
  custom: Themes.custom.backgroundColor
});

const ContainerStyles = () => {
  return css`
    padding: ${props => (props.inline ? '10px' : 0)};
    position: ${props => (props.inline ? 'relative' : 'fixed')};
  `;
};

const Text = styled.small`
  display: block;
  margin-top: 1rem;
`;

const Overlay = styled.div`
  align-items: center;
  background-color: ${props => (props.inline ? 'inherit' : backgroundColor)};
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  left: 0;
  overflow: hidden;
  top: 0;
  transition: 0.5s;
  width: 100%;
  z-index: 1;

  ${ContainerStyles()};
`;

const CancelButton = styled(Button)`
  margin-top: 1rem;
`;

type Props = {
  inline?: boolean,
  size?: FontAwesomeSize,
  text?: string,
  delay?: number,
  onCancel?: () => void
};

const BusyIndicator = (props: Props) => {
  const isExpired = useDelay(props.delay);

  if (props.delay && !isExpired) return null;

  return (
    <Overlay inline={props.inline}>
      <FontAwesomeIcon icon={['far', 'spinner-third']} size={props.size} spin />
      {props.text && <Text>{props.text}</Text>}
      {props.onCancel && (
        <CancelButton kind="primary" onClick={props.onCancel}>
          Cancel
        </CancelButton>
      )}
    </Overlay>
  );
};

BusyIndicator.defaultProps = {
  inline: false,
  size: '3x',
  text: '',
  delay: 0
};

export default React.memo<Props>(BusyIndicator);
